export default function AddressScheme({ d }) {
  if (!d) return null;
  const rows = [["Online", d.live_example, "indicizzabile"], ["Anteprima", d.preview_example, "noindex"], ["Versione (24 h)", d.version_example, "noindex"]];
  return (
    <dl className="grid gap-2 sm:grid-cols-3" data-testid="hosting-address-scheme">
      {rows.map(([label, host, note]) => (
        <div key={label} className="min-w-0 rounded-lg border border-slate-200 bg-slate-50/60 px-3 py-2.5">
          <dt className="text-[11px] font-medium uppercase tracking-wider text-slate-500">{label}</dt>
          <dd className="mt-1 break-all font-mono text-xs text-slate-800">{d.scheme}://{host}</dd>
          <dd className="text-[11px] text-slate-400">{note}</dd>
        </div>
      ))}
    </dl>
  );
}

export function DnsRecords({ d }) {
  if (!d) return null;
  return (
    <div className="overflow-x-auto rounded-lg border border-slate-200" data-testid="hosting-dns-records">
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-[11px] uppercase tracking-wider text-slate-500"><tr>{["Tipo", "Nome", "Contenuto", "Proxy", "A cosa serve"].map((x) => <th key={x} className="px-3 py-2 text-left font-medium">{x}</th>)}</tr></thead>
        <tbody>
          {d.dns_records.map((r) => (
            <tr key={r.name} className="border-t border-slate-100">
              <td className="px-3 py-2 font-mono text-xs">{r.type}</td><td className="px-3 py-2 font-mono text-xs">{r.name}</td><td className="px-3 py-2 font-mono text-xs">{r.value}</td>
              <td className="px-3 py-2 text-xs">{r.proxied ? "Attivo (nuvola arancione)" : "No"}</td><td className="px-3 py-2 text-xs text-slate-500 min-w-[220px]">{r.why}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
